var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBusiness = function SvgBusiness(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 176,
    y1: 416,
    x2: 176,
    y2: 480,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,32H272a32,32,0,0,1,32,32V476a4,4,0,0,1-4,4H48a0,0,0,0,1,0,0V64A32,32,0,0,1,80,32Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,192H432a32,32,0,0,1,32,32V480a0,0,0,0,1,0,0H304a0,0,0,0,1,0,0V208A16,16,0,0,1,320,192Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.08,431.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,431.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.08,351.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,351.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.08,271.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,271.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.08,191.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,191.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.08,111.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,111.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.08,351.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,178.08,351.87Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.08,271.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,178.08,271.87Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.08,191.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,178.08,191.87Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.08,111.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,178.08,111.87Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.08,431.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,258.08,431.87Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.08,351.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,258.08,351.87Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M258.08,271.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,258.08,271.87Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 176,
    rx: 15.95,
    ry: 16.03,
    transform: "translate(-49.47 232.56) rotate(-45)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M258.08,111.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,258.08,111.87Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M400,400a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M400,320a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M400,240a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M336,400a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M336,320a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M336,240a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBusiness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/business.3a4d748c.svg";
export { ForwardRef as ReactComponent };